module.exports = __webpack_public_path__ + "img/tiktok.c266b2a8.svg";